const MAX_VISIBLE_ALLERGIES = 2;

export const getHomeAllergySummary = (records = []) => {
  const names = [...new Set((Array.isArray(records) ? records : [])
    .map((item) => typeof item === 'string' ? item.trim() : String(item?.label || item?.name || '').trim())
    .filter(Boolean))];
  const allergies = names.filter((name) => name.toLowerCase() !== 'none');
  if (!allergies.length) {
    return {
      title: 'Allergies',
      description: names.length ? 'No known allergies recorded' : 'No allergies recorded',
    };
  }
  const remaining = allergies.length - MAX_VISIBLE_ALLERGIES;
  return {
    title: `Allergies · ${allergies.length}`,
    description: `${allergies.slice(0, MAX_VISIBLE_ALLERGIES).join(', ')}${remaining > 0 ? ` · +${remaining} more` : ''}`,
  };
};
